module.exports = {"331021001":"玉城街道","331021002":"坎门街道","331021003":"大麦屿街道","331021101":"清港镇","331021102":"楚门镇","331021103":"干江镇","331021105":"沙门镇","331021106":"芦浦镇","331021107":"龙溪镇","331021201":"鸡山乡","331021202":"海山乡","331021400":"玉环经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/331021.json
// module id = 1019
// module chunks = 0